/*
 * NFT Landing Page - Sailing Ships Collection
 * Copyright (C) 2025 jsaif
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program. If not, see <https://www.gnu.org/licenses/>.
 *
 * Original project: https://github.com/s-shemmee/NFT-Portfolio-Landing-Page
 * Original creator: s-shemmee
 */

import React from "react";
import PropTypes from "prop-types";
import "./Footer.css";
// Social link component
const SocialLink = ({ href, iconClass, label }) => (
  <li>
    <a href={href} target="_blank" rel="noopener noreferrer" title={label}>
      <i className={iconClass}></i>
    </a>
  </li>
);

// Props validation
SocialLink.propTypes = {
  href: PropTypes.string.isRequired,
  iconClass: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};

// Footer link component
const FooterLink = ({ href, text }) => (
  <li>
    <a href={href} target="_blank" rel="noopener noreferrer">
      {text}
    </a>
  </li>
);

// Props validation
FooterLink.propTypes = {
  href: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

// Array of social links
const socialLinks = [
  {
    href: "https://x.com/jubi_25",
    iconClass: "bi bi-twitter",
    label: "Twitter",
  },
];

// Array of footer links
const footerLinks = [
  // { href: "/", text: "Blog" },
  // { href: "/", text: "Privacy" },
  // { href: "/", text: "Terms of use" },
  // { href: "/", text: "Sign In" },
  // { href: "/", text: "Sign Up" },
];

export default function Footer() {
  return (
    <section id="footer" className="Footer">
      {/* Chess image overlays to ensure proper layering */}
      <div className="chess-overlay-left"></div>
      <div className="chess-overlay-right"></div>

      <div className="container">
        <div className="row">
          <div className="join-us">
            <h1>
              <span>FOLLOW US ON X</span>
            </h1>
            <p className="subtitle">Stay updated with the latest from our NFT collection.</p>
            <div className="cta">
              <a href="https://x.com/jubi_25" target="_blank" rel="noopener noreferrer">
                Follow on X
              </a>
            </div>
          </div>

          <ul className="social-links">
            {socialLinks.map((link, index) => (
              <SocialLink
                key={`${link.label}-${link.href}`}
                href={link.href}
                iconClass={link.iconClass}
                label={link.label}
              />
            ))}
          </ul>

          <ul className="footer-links">
            {footerLinks.map((link, index) => (
              <FooterLink key={`${link.text}-${link.href}`} href={link.href} text={link.text} />
            ))}
          </ul>

          <p className="copy">© 2025 Sailing Ships NFT Collection. All rights reserved.</p>
        </div>
      </div>
    </section>
  );
}
